import React, { useEffect, useRef } from "react";
import { DetailTextType } from "../types/FeatureModuleDetail";
import { CtaButton } from "../Cta/cta-button";

const DetailtText = ({
  item,
  setActiveIndex,
  index,
  onClick,
}: DetailTextType) => {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio > 0.95) {
          setActiveIndex(index);
        }
      },
      {
        threshold: [0.95],
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref, index]);

  return (
    <div
      className={`h-screen flex items-center py-[66px] px-[80px] [@media(min-width:1441px)]:justify-start [@media(min-width:1441px)]:pl-[120px] w-full justify-center text-2xl font-bold text-gray-800 bg-white`}
    >
      <div className="h-full flex justify-center flex-col w-full max-w-[480px]">
        <h4
          className="feature-module__header text-left pb-3"
          ref={ref}
          dangerouslySetInnerHTML={{ __html: item.headline }}
        />
        <div
          className="feature-module__text body--text-regular text-left pb-8"
          dangerouslySetInnerHTML={{ __html: item.Subcopy }}
        ></div>
        <div className="flex">
          {item?.ctaCopy && (
            <CtaButton
              variant="tertiarySun"
              copy={item.ctaCopy}
              copySize="bodyRegular"
              isDisabled={false}
              link={item?.ctaLink?.value?.data?.url || null}
              linkUrl={item?.ctaUrl || null}
              onClick={onClick}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailtText;
